/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Feedback } from 'src/app/models/feedback';
import { ConfigService } from '@windriver/authentication';

/**
 * Posts Feedback model object as JSON to the configured postFeedbackUrl
 */
@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiBackendBaseUrl: string;

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
      // TODO: include auth header
    })
  };

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.configService.configState.subscribe((config: any) => {
      if (config) {
        this.apiBackendBaseUrl = config.apiUrl;
      }
    });
  }

  submitFeedback(feedback: Feedback): Observable<Feedback> {
    // TODO - set correct URL for posting feedback
    return this.http
      .post<Feedback>(this.apiBackendBaseUrl + '/feedback', feedback, this.httpOptions)
      .pipe(catchError((error) => throwError(`Error posting feedback. ${JSON.stringify(error)}`)));
  }
}
